// Toggle for wavy background animation
export const ENABLE_WAVY_BG_ANIMATION = false;

// Helper function to conditionally apply animation classes
const getAnimationClass = (baseClass, animatedClass) => {
  return ENABLE_WAVY_BG_ANIMATION ? `${baseClass} ${animatedClass}` : baseClass;
};

export const MAIN_BG_GRADIENT = getAnimationClass(
  "bg-gradient-to-tr from-[#967E76] via-[#EEE3CB] to-[#D7C0AE] dark:from-[#967E76] dark:via-[#9BABB8] dark:to-[#D7C0AE]",
  "animate-wavy-gradient"
);

export const MAIN_BG_GRADIENT_ANIMATED = getAnimationClass(
  "bg-gradient-to-tr from-[#967E76] via-[#EEE3CB] to-[#D7C0AE] dark:from-[#967E76] dark:via-[#9BABB8] dark:to-[#D7C0AE] bg-[length:400%_400%]",
  "animate-wavy-gradient"
);

export const WAVY_BG_GRADIENT = getAnimationClass(
  "bg-gradient-to-tr from-[#967E76] via-[#EEE3CB] to-[#D7C0AE] dark:from-[#967E76] dark:via-[#9BABB8] dark:to-[#D7C0AE]",
  "animate-wavy-bg"
);

export const DESIGNED_BG_GRADIENT = getAnimationClass(
  "bg-gradient-to-tr from-[#967E76] via-[#EEE3CB] to-[#D7C0AE] dark:from-[#967E76] dark:via-[#9BABB8] dark:to-[#D7C0AE] before:absolute before:inset-0 before:bg-[url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\"%3E%3Cg fill=\"none\" fill-rule=\"evenodd\"%3E%3Cg fill=\"%23ffffff\" fill-opacity=\"0.05\"%3E%3Ccircle cx=\"30\" cy=\"30\" r=\"2\"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')]",
  "animate-wavy-gradient before:animate-float"
);

export const GEOMETRIC_BG_GRADIENT = getAnimationClass(
  "bg-gradient-to-tr from-[#967E76] via-[#EEE3CB] to-[#D7C0AE] dark:from-[#967E76] dark:via-[#9BABB8] dark:to-[#D7C0AE] before:absolute before:inset-0 before:bg-[url('data:image/svg+xml,%3Csvg width=\"80\" height=\"80\" viewBox=\"0 0 80 80\" xmlns=\"http://www.w3.org/2000/svg\"%3E%3Cg fill=\"none\" fill-rule=\"evenodd\"%3E%3Cg fill=\"%23ffffff\" fill-opacity=\"0.03\"%3E%3Cpolygon points=\"40 0 60 20 60 40 40 60 20 40 20 20\"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')]",
  "animate-wavy-bg before:animate-pulse-slow"
);

export const DOTTED_BG_GRADIENT = getAnimationClass(
  "bg-gradient-to-tr from-[#967E76] via-[#EEE3CB] to-[#D7C0AE] dark:from-[#967E76] dark:via-[#9BABB8] dark:to-[#D7C0AE] before:absolute before:inset-0 before:bg-[url('data:image/svg+xml,%3Csvg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"%3E%3Cg fill=\"none\" fill-rule=\"evenodd\"%3E%3Cg fill=\"%23ffffff\" fill-opacity=\"0.04\"%3E%3Ccircle cx=\"20\" cy=\"20\" r=\"1.5\"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')]",
  "animate-wavy-gradient before:animate-fade-in-out"
);

export const WAVE_PATTERN_BG_GRADIENT = getAnimationClass(
  "bg-gradient-to-tr from-[#967E76] via-[#EEE3CB] to-[#D7C0AE] dark:from-[#967E76] dark:via-[#9BABB8] dark:to-[#D7C0AE] before:absolute before:inset-0 before:bg-[url('data:image/svg+xml,%3Csvg width=\"100\" height=\"20\" viewBox=\"0 0 100 20\" xmlns=\"http://www.w3.org/2000/svg\"%3E%3Cpath d=\"M0 10 Q25 0 50 10 T100 10\" stroke=\"%23ffffff\" stroke-width=\"0.5\" fill=\"none\" opacity=\"0.06\"/%3E%3C/svg%3E')]",
  "animate-wavy-bg before:animate-float-slow"
);

// Static gradient without any animation (for when toggle is off)
export const STATIC_BG_GRADIENT =
  "bg-gradient-to-tr from-[#967E76] via-[#EEE3CB] to-[#D7C0AE] dark:from-[#967E76] dark:via-[#9BABB8] dark:to-[#D7C0AE]";
